"use strict";
var cleanURL = require("../plugins/cleanurl"), XHR = require("./xhr"), delay = require("./utils/delay"), RequestError = require("./error"), Response = require("./response"), Request = require("./request"), extend = require("xtend"), once = require("./utils/once");
var i, createError = RequestError.create;
function factory(defaults, plugins) {
  defaults = defaults || {};
  plugins = plugins || [];
  function http(req, cb) {
    var xhr, plugin, done, k, timeoutId, supportsLoadAndErrorEvents;
    req = new Request(extend(defaults, req));
    for (i = 0; i < plugins.length; i++) {
      plugin = plugins[i];
      if (plugin.processRequest) {
        plugin.processRequest(req);
      }
    }
    for (i = 0; i < plugins.length; i++) {
      plugin = plugins[i];
      if (plugin.createXHR) {
        xhr = plugin.createXHR(req);
        break;
      }
    }
    xhr = xhr || new XHR();
    req.xhr = xhr;
    done = once(delay(function(rawError) {
      clearTimeout(timeoutId);
      xhr.onload = xhr.onerror = xhr.onabort = xhr.onreadystatechange = xhr.ontimeout = xhr.onprogress = null;
      var err = getError(req, rawError);
      var res = err || Response.fromRequest(req);
      for (i = 0; i < plugins.length; i++) {
        plugin = plugins[i];
        if (plugin.processResponse) {
          plugin.processResponse(res);
        }
      }
      if (err && req.onerror) req.onerror(err);
      if (!err && req.onload) req.onload(res);
      if (cb) cb(err, err ? void 0 : res);
    }));
    supportsLoadAndErrorEvents = "onload" in xhr && "onerror" in xhr;
    xhr.onload = function() {
      done();
    };
    xhr.onerror = done;
    xhr.onabort = function() {
      done();
    };
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;
      if (req.aborted) return done();
      if (!supportsLoadAndErrorEvents) {
        var status;
        try {
          status = xhr.status;
        } catch (err2) {
        }
        var err = status === 0 ? new Error("Internal XHR Error") : null;
        return done(err);
      }
    };
    xhr.ontimeout = function() {
    };
    xhr.onprogress = function() {
    };
    xhr.open(req.method, req.url);
    if (req.timeout) {
      timeoutId = setTimeout(function() {
        req.timedOut = true;
        done();
        try {
          xhr.abort();
        } catch (err) {
        }
      }, req.timeout);
    }
    for (k in req.headers) {
      if (req.headers.hasOwnProperty(k)) {
        xhr.setRequestHeader(k, req.headers[k]);
      }
    }
    xhr.send(req.body);
    return req;
  }
  var method, methods = ["get", "post", "put", "head", "patch", "delete"], verb = function(method2) {
    return function(req, cb) {
      req = new Request(req);
      req.method = method2;
      return http(req, cb);
    };
  };
  for (i = 0; i < methods.length; i++) {
    method = methods[i];
    http[method] = verb(method);
  }
  http.plugins = function() {
    return plugins;
  };
  http.defaults = function(newValues) {
    if (newValues) {
      return factory(extend(defaults, newValues), plugins);
    }
    return defaults;
  };
  http.use = function() {
    var newPlugins = Array.prototype.slice.call(arguments, 0);
    return factory(defaults, plugins.concat(newPlugins));
  };
  http.bare = function() {
    return factory();
  };
  http.Request = Request;
  http.Response = Response;
  http.RequestError = RequestError;
  return http;
}
module.exports = factory({}, [cleanURL]);
function getError(req, err) {
  if (req.aborted) return createError("Request aborted", req, { name: "Abort" });
  if (req.timedOut) return createError("Request timeout", req, { name: "Timeout" });
  var xhr = req.xhr;
  var type = Math.floor(xhr.status / 100);
  var kind;
  switch (type) {
    case 0:
    case 2:
      if (!err) return;
      return createError(err.message, req);
    case 4:
      if (xhr.status === 404 && !req.errorOn404) return;
      kind = "Client";
      break;
    case 5:
      kind = "Server";
      break;
    default:
      kind = "HTTP";
  }
  var msg = kind + " Error: The server returned a status of " + xhr.status + ' for the request "' + req.method.toUpperCase() + " " + req.url + '"';
  return createError(msg, req);
}
